import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "w-full h-[calc(100vh-52px)] overflow-y-auto bg-[#F1F0EE]" }
const _hoisted_2 = { class: "max-w-[900px] mx-auto px-6 py-8" }
const _hoisted_3 = { class: "grid grid-cols-4 gap-3 mb-6" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "text-2xl font-semibold text-gray-900" }
const _hoisted_6 = { class: "text-xs text-[#898790] mt-0.5" }
const _hoisted_7 = { class: "bg-white rounded-xl overflow-hidden" }
const _hoisted_8 = {
  key: 0,
  class: "flex items-center justify-center py-16 text-sm text-[#898790]"
}
const _hoisted_9 = {
  key: 1,
  class: "flex items-center justify-center py-16 text-sm text-[#898790]"
}
const _hoisted_10 = ["onClick"]
const _hoisted_11 = { class: "flex-1 min-w-0" }
const _hoisted_12 = { class: "text-sm font-medium text-gray-900 truncate" }
const _hoisted_13 = { class: "text-xs text-[#898790] truncate mt-0.5" }
const _hoisted_14 = { class: "text-xs text-[#898790] w-24 shrink-0" }
const _hoisted_15 = { class: "w-28 shrink-0" }
const _hoisted_16 = { class: "w-4 shrink-0" }
const _hoisted_17 = {
  key: 0,
  class: "px-5 pb-4"
}
const _hoisted_18 = { class: "bg-red-50 rounded-lg px-4 py-3 text-sm text-gray-700 leading-relaxed" }

import MainLayout from "@/layouts/MainLayout.vue";
import axios from "axios";
import { onMounted, ref, computed } from "vue";
import { useUserStore } from "@/stores/user";

type ReviewStatus = "pending" | "sent" | "positive" | "negative";

interface ReviewRequest {
  id: number;
  project_id: number;
  project_name: string | null;
  customer_id: number;
  customer_name: string | null;
  partner_name: string | null;
  status: ReviewStatus;
  sent_at: string | null;
  responded_at: string | null;
  feedback_text: string | null;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'ReviewsView',
  setup(__props) {

const userStore = useUserStore();
const api = axios.create({
  baseURL: process.env.VUE_APP_API_ENDPOINT + "/api/v1",
  headers: { "Content-Type": "application/json" },
});
api.interceptors.request.use((config) => {
  config.headers["x-supabase-auth"] = userStore.getAccessToken;
  return config;
});

const reviews = ref<ReviewRequest[]>([]);
const isLoading = ref(false);
const activeFilter = ref<ReviewStatus | "all">("all");
const expandedFeedback = ref<number | null>(null);

const statusFilters: { key: ReviewStatus | "all"; label: string }[] = [
  { key: "all", label: "Alle" },
  { key: "sent", label: "Keine Antwort" },
  { key: "positive", label: "Positiv" },
  { key: "negative", label: "Negativ" },
];

const filtered = computed(() => {
  if (activeFilter.value === "all") return reviews.value;
  if (activeFilter.value === "sent")
    return reviews.value.filter(
      (r) => r.status === "sent" || r.status === "pending"
    );
  return reviews.value.filter((r) => r.status === activeFilter.value);
});

const counts = computed(() => ({
  all: reviews.value.length,
  sent: reviews.value.filter(
    (r) => r.status === "sent" || r.status === "pending"
  ).length,
  positive: reviews.value.filter((r) => r.status === "positive").length,
  negative: reviews.value.filter((r) => r.status === "negative").length,
}));

function formatDate(iso: string | null) {
  if (!iso) return "—";
  return new Date(iso).toLocaleDateString("de-DE", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
  });
}

async function fetchReviews() {
  isLoading.value = true;
  try {
    const { data } = await api.get("/reviews/", { params: { limit: 500 } });
    reviews.value = data.review_requests;
  } catch (e) {
    console.error(e);
  } finally {
    isLoading.value = false;
  }
}

onMounted(fetchReviews);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(MainLayout, null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _cache[1] || (_cache[1] = _createElementVNode("div", { class: "mb-6" }, [
            _createElementVNode("h1", { class: "text-xl font-semibold text-primary-text-color tracking-[0.01rem]" }, " Bewertungen "),
            _createElementVNode("p", { class: "text-sm text-[#898790] mt-1" }, " Übersicht aller versendeten Bewertungsanfragen ")
          ], -1)),
          _createElementVNode("div", _hoisted_3, [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(statusFilters, (f) => {
              return _createElementVNode("button", {
                key: f.key,
                onClick: ($event: any) => (activeFilter.value = f.key),
                class: _normalizeClass(["bg-white rounded-xl px-4 py-3 text-left transition border-2", 
              activeFilter.value === f.key
                ? 'border-gray-900'
                : 'border-transparent hover:border-gray-200'
            ])
              }, [
                _createElementVNode("div", _hoisted_5, _toDisplayString(counts.value[f.key]), 1),
                _createElementVNode("div", _hoisted_6, _toDisplayString(f.label), 1)
              ], 10, _hoisted_4)
            }), 64))
          ]),
          _createElementVNode("div", _hoisted_7, [
            (isLoading.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, " Lädt... "))
              : (filtered.value.length === 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_9, " Keine Einträge "))
                : (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList(filtered.value, (review) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: review.id,
                      class: "border-b border-gray-100 last:border-0"
                    }, [
                      _createElementVNode("div", {
                        class: "flex items-center px-5 py-3.5 gap-4 cursor-pointer hover:bg-gray-50 transition",
                        onClick: ($event: any) => (
                  expandedFeedback.value =
                    expandedFeedback.value === review.id ? null : review.id
                )
                      }, [
                        _createElementVNode("div", _hoisted_11, [
                          _createElementVNode("div", _hoisted_12, _toDisplayString(review.customer_name || "—"), 1),
                          _createElementVNode("div", _hoisted_13, _toDisplayString(review.project_name || `Projekt #${review.project_id}`), 1)
                        ]),
                        _createElementVNode("div", _hoisted_14, _toDisplayString(formatDate(review.sent_at)), 1),
                        _createElementVNode("div", _hoisted_15, [
                          _createElementVNode("span", {
                            class: _normalizeClass(["inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-medium", {
                      'bg-gray-100 text-gray-500':
                        review.status === 'sent' || review.status === 'pending',
                      'bg-green-50 text-green-700':
                        review.status === 'positive',
                      'bg-red-50 text-red-600': review.status === 'negative',
                    }])
                          }, [
                            _createElementVNode("span", {
                              class: _normalizeClass(["w-1.5 h-1.5 rounded-full", {
                        'bg-gray-400':
                          review.status === 'sent' ||
                          review.status === 'pending',
                        'bg-green-500': review.status === 'positive',
                        'bg-red-500': review.status === 'negative',
                      }])
                            }, null, 2),
                            _createTextVNode(" " + _toDisplayString(review.status === "positive"
                        ? "Positiv"
                        : review.status === "negative"
                        ? "Negativ"
                        : "Keine Antwort"), 1)
                          ], 2)
                        ]),
                        _createElementVNode("div", _hoisted_16, [
                          (review.status === 'negative' && review.feedback_text)
                            ? (_openBlock(), _createElementBlock("svg", {
                                key: 0,
                                class: _normalizeClass(["w-4 h-4 text-gray-400 transition-transform", expandedFeedback.value === review.id ? 'rotate-180' : '']),
                                fill: "none",
                                stroke: "currentColor",
                                "stroke-width": "2",
                                viewBox: "0 0 24 24"
                              }, [...(_cache[0] || (_cache[0] = [
                                _createElementVNode("path", {
                                  "stroke-linecap": "round",
                                  "stroke-linejoin": "round",
                                  d: "M19 9l-7 7-7-7"
                                }, null, -1)
                              ]))], 2))
                            : _createCommentVNode("", true)
                        ])
                      ], 8, _hoisted_10),
                      (
                  review.status === 'negative' &&
                  review.feedback_text &&
                  expandedFeedback.value === review.id
                )
                        ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                            _createElementVNode("div", _hoisted_18, " \"" + _toDisplayString(review.feedback_text) + "\" ", 1)
                          ]))
                        : _createCommentVNode("", true)
                    ]))
                  }), 128))
          ])
        ])
      ])
    ]),
    _: 1
  }))
}
}

})